import ReactDOM from "react-dom";
const DropdownTest = ({ isOpen, buttonRef, children }) => {
  if (!isOpen || !buttonRef) return null;

  const buttonRect = buttonRef.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      className="absolute z-50  rounded-lg shadow-lg"
      style={{
        top: buttonRect.bottom + window.scrollY + 5, // Adjust for spacing below button
        left: buttonRect.left + window.scrollX - 90, // Move dropdown slightly left
        minWidth: buttonRect.width + 20, // Slightly wider for better UI
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default DropdownTest;